export const isAncestorScrollable = (element: HTMLElement) => {
  if (!element) return false;

  if (element === document.body) return false;

  const style = window.getComputedStyle(element);
  const overflow = style.getPropertyValue('overflow');
  const overflowY = style.getPropertyValue('overflow-y');

  if (
    overflow === 'scroll' ||
    overflowY === 'scroll' ||
    overflow === 'auto' ||
    overflowY === 'auto'
  ) {
    // only care for divs (comments in manuals)
    if (element.tagName === 'DIV') return true;
  }

  if (!element.parentElement) return false;

  return isAncestorScrollable(element.parentElement);
};